import { gql } from "@apollo/client";

export const GetAttributeReferenceData = gql`
  query GetAttributeReferenceData($entityType: String, $attributeId: String, $searchTerm: JSON) {
    GetAttributeReferenceData(
      entityType: $entityType
      attributeId: $attributeId
      searchTerm: $searchTerm
    )
  }
`;
